import { useCallback, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { ethers } from 'ethers'
import useToast from 'hooks/useToast'
import { useERC20 } from 'hooks/useContract'
import { useTranslation } from 'contexts/Localization'
import { useAppDispatch } from 'state'
import { getAddress, getDmdAddress } from 'utils/addressHelpers'
import { multiPoolConfig } from 'config/constants'
import { fetchMultiPoolUserDataAsync } from 'state/multiPool'

const useApproveMultiPool = () => {
  const dispatch = useAppDispatch()
  const { toastSuccess, toastError } = useToast()
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const [isApproving, setIsApproving] = useState(false)
  const dmdContract = useERC20(getDmdAddress())

  const handleApproveMultiPool = useCallback(
    async () => {
      try {
        setIsApproving(true)
        const tx = await dmdContract.approve(getAddress(multiPoolConfig.contractAddress), ethers.constants.MaxUint256)
        const receipt = await tx.wait()
        const status = receipt?.status

        if (status) {
          toastSuccess(
            t('Contract Enabled'),
            t('You can now stake!'),
          )
          dispatch(fetchMultiPoolUserDataAsync(account))
        } else {
          toastError(
            t('Error'),
            t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
          )
        }

        setIsApproving(false)
      } catch (e) {
        console.error(e)
        toastError(
          t('Error'),
          t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
        )
        setIsApproving(false)
      }
    },
    [dmdContract, dispatch, t, toastSuccess, toastError, account],
  )

  return { handleApproveMultiPool, isApproving }
}

export default useApproveMultiPool
